import styled, {css} from "styled-components"

import {spacingCss, SpacingProps} from "../global/css"
import {hoverRaise} from "../global/css/animations"

interface AddPaddingProps {
  large?: boolean
  medium?: boolean
  small?: boolean
  tiny?: boolean
  flush?: boolean
}

export interface CardProps extends AddPaddingProps, SpacingProps {
  noBorder?: boolean
  rollover?: boolean
  bgColor?: string
}

const addPadding = ({large, medium, small, tiny, flush}: AddPaddingProps, spacing) => {
  if (large) {
    return spacing.eight
  } else if (medium) {
    return spacing.four
  } else if (small) {
    return spacing.two
  } else if (tiny) {
    return spacing.one
  } else if (flush) {
    return 0
  }
  return spacing.four
}

export default styled.div<CardProps>`
  display: block;
  clear: both;
  ${(props) => `
    padding: ${addPadding(props, props.theme.spacing)};
  `}
  ${({theme, tiny, flush, noBorder, rollover, margin, bgColor}) => css`
    border-radius: ${theme.spacing.one};
    background-color: ${bgColor || theme.colors.utility.white};
    ${!noBorder && `box-shadow: ${theme.shadows.low};`}
    ${margin && `margin: ${margin};`}

    ${rollover && hoverRaise}

    ${theme.mediaQueries.maxWidthMedia.tablet`
      ${!(tiny || flush) && `padding: ${theme.spacing.two};`}
    `}
  `}
  ${spacingCss}
`
